import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionQuotationPage_SaveMissionQuotationPreview_Mutation =
  graphql(`
    mutation MissionQuotationPage_SaveMissionQuotationPreview(
      $printableId: Id!
      $versionData: VersionDataInput
    ) {
      saveQuotationPreview(
        printableId: $printableId
        versionData: $versionData
      ) {
        ...PrinterContextProvider_PdfPrint_Fragment
      }
    }
  `);

export type SaveMissionQuotationPreview_Result = ResultOf<
  typeof MissionQuotationPage_SaveMissionQuotationPreview_Mutation
>;

export const useSavePreviewMutation = () =>
  useGraphQLMutation(MissionQuotationPage_SaveMissionQuotationPreview_Mutation);
